import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { LoadingBarService } from '@ngx-loading-bar/core';
import { FormGroup, FormControl, Validators, FormBuilder } from '@angular/forms';
import { NotificationService } from 'app/_services/notification.service';
import { Globals } from 'app/_globals';
import { CookieService } from 'ngx-cookie-service';
import { StoreService } from '../../_services/store.service';
import { GroupUserService } from '../../_services/group-user.service';
import { OwnerUserService } from '../../_services/owner-user.service';
import { AppsService } from '../../_services/apps.service';

@Component({
    selector: 'app-store-details',
    templateUrl: './store-details.component.html',
    styleUrls: ['./store-details.component.css'],
})
export class StoreDetailsComponent implements OnInit {
    tabitems: any = [];

    storeId: any;
    selectedStore: any;
    cookieStore: any;
    storeDetailsForm: FormGroup;

    role: any;
    routeRole: any;

    currencies: any = this.globals.currencies;

    currentGroup: any;
    groups: GroupUser[] = [{ label: 'None', value: null }];
    groupFunctionSuccess = false; // Hide dropdown until function complete
    currentOwner: any;
    owners: OwnerUser[] = [{ label: 'None', value: null }];
    ownerFunctionSuccess = false; // Hide dropdown until function complete
    currentApp: any;
    apps: CustomerApp[] = [{ label: 'None', value: null }];
    appFunctionSuccess = false; // Hide dropdown until function complete

    dropdownPagination = {
        size: 10000,
        page: 0,
    };

    constructor(
        public fb: FormBuilder,
        public activatedRoute: ActivatedRoute,
        public loader: LoadingBarService,
        public notificationService: NotificationService,
        public globals: Globals,
        public cookieService: CookieService,
        public router: Router,
        public _storeService: StoreService,
        public _groupUserService: GroupUserService,
        public _ownerUserService: OwnerUserService,
        public _appsService: AppsService
    ) {
        const hasCurrentStore = cookieService.check('currentStore');
        if (hasCurrentStore) {
            this.cookieStore = JSON.parse(cookieService.get('currentStore'));
            this.storeId = this.cookieStore.id;
        } else {
            this.router.navigate(['/' + this.globals.user.routeRole + '/select-store']);
        }

        this.role = globals.user.role;
        this.routeRole = globals.user.routeRole;

        this.tabitems = [
            { path: '/' + this.routeRole + '/store/details', title: 'Details' },
            { path: '/' + this.routeRole + '/store/location', title: 'Location' },
            { path: '/' + this.routeRole + '/store/opening-times', title: 'Ordering Times' },
            { path: '/' + this.routeRole + '/store/media', title: 'Media' },
            { path: '/' + this.routeRole + '/store/payment-setup', title: 'Payment Setup' },
            { path: '/' + this.routeRole + '/store/pos-setup', title: 'POS Setup' },
            { path: '/' + this.routeRole + '/store/services', title: 'Services' },
        ];

        this.storeDetailsForm = fb.group({
            name: new FormControl(''),
            address1: new FormControl(''),
            address2: new FormControl(''),
            city: new FormControl(''),
            postcode: new FormControl(''),
            currency: new FormControl(''),
            phoneNumber: new FormControl(''),
            enabled: new FormControl(''),
        });
    }

    ngOnInit() {
        this.getStore(this.storeId);
    }

    public initialise() {
        setTimeout(() => {
            if (this.globals.user.routeRole === 'group') {
                this.getAllOwners(this.role);
                this.getAllApps(this.role);
            } else {
                this.getAllGroups(this.role);
                this.getAllOwners(this.role);
                this.getAllApps(this.role);
            }
        }, 1000);
    }

    // Get Store by id
    public getStore(id) {
        this._storeService.getStoreById(id).subscribe(
            (data: any) => {
                this.initialise();
                // console.log(data);
                this.selectedStore = data;
                this.assignFormValues();
                if (
                    data.storeConfig !== null &&
                    data.storeConfig.deliveryOrders &&
                    this.tabitems.filter((item) => item.title === 'Delivery Times').length === 0
                ) {
                    this.tabitems.push({
                        path: '/' + this.routeRole + '/store/delivery-times',
                        title: 'Delivery Times',
                    });
                } else if (
                    data.storeConfig !== null &&
                    data.storeConfig.deliveryOrders === false &&
                    this.tabitems.filter((item) => item.title === 'Delivery Times').length === 1
                ) {
                    this.tabitems.splice(
                        this.tabitems.findIndex((item) => item.title === 'Delivery Times'),
                        1
                    );
                }
                if (
                    data.storeConfig !== null &&
                    data.storeConfig.kioskOrders &&
                    this.tabitems.filter((item) => item.title === 'Kiosks').length === 0
                ) {
                    this.tabitems.push({ path: '/' + this.routeRole + '/store/kiosks', title: 'Kiosks' });
                } else if (
                    data.storeConfig !== null &&
                    data.storeConfig.kioskOrders === false &&
                    this.tabitems.filter((item) => item.title === 'Kiosks').length === 1
                ) {
                    this.tabitems.splice(
                        this.tabitems.findIndex((item) => item.title === 'Kiosks'),
                        1
                    );
                }
            },
            (err) => {
                console.log('Getting store by ID error, navigate to select store');
                this.router.navigate(['/' + this.globals.user.routeRole + '/select-store']);
            }
        );
    }

    public assignFormValues() {
        this.storeDetailsForm.patchValue({
            name: this.selectedStore.name,
            address1: this.selectedStore.address1,
            address2: this.selectedStore.address2,
            city: this.selectedStore.city,
            postcode: this.selectedStore.postcode,
            currency: { value: this.selectedStore.currency },
            phoneNumber: this.selectedStore.phoneNumber,
            enabled: this.selectedStore.enabled,
        });
    }

    public onOwnerChange(event) {
        console.log(event);
        this._storeService.setStoreOwner(this.storeId, event.value.id).subscribe((data: any) => {
            console.log(data);
            this.notificationService.notify(
                'success',
                'Owner Assigned',
                'Store has successfully been assigned an owner',
                'top',
                'right'
            );
        });
    }

    public onGroupChange(event) {
        console.log(event);
        this._storeService.setStoreGroup(this.storeId, event.value.id).subscribe((data: any) => {
            console.log(data);
            this.notificationService.notify(
                'success',
                'Group Assigned',
                'Store has successfully been assigned to Group',
                'top',
                'right'
            );
        });
    }

    public onAppChange(event) {
        console.log(event);
        this._storeService.setStoreApp(this.storeId, event.value.id).subscribe((data: any) => {
            console.log(data);
            this.notificationService.notify(
                'success',
                'App Assigned',
                'Store has successfully been assigned to app',
                'top',
                'right'
            );
        });
    }

    public getAllGroups(role) {
        if (role > 2) {
            this._groupUserService
                .getAllGroups(this.dropdownPagination, 'bludotUser.organisation,asc')
                .subscribe((data: any) => {
                    // console.log('All Groups -> ', data.body);
                    data.body.forEach((element) => {
                        if (
                            this.selectedStore.groupUser !== null &&
                            element.id === this.selectedStore.groupUser.id
                        ) {
                            this.currentGroup = { label: element.organisation, value: element };
                        }
                        const obj = {
                            label: element.organisation,
                            value: element,
                        };
                        this.groups.push(obj);
                    });
                    this.groupFunctionSuccess = true;
                });
        }
    }

    public getAllOwners(role) {
        if (role > 2) {
            this._ownerUserService
                .getAllOwners(this.dropdownPagination, 'bludotUser.user.lastName,asc')
                .subscribe((data: any) => {
                    // console.log('All Owners -> ', data.body);
                    data.body.forEach((element) => {
                        if (
                            this.selectedStore.storeOwnerUser !== null &&
                            element.id === this.selectedStore.storeOwnerUser.id
                        ) {
                            this.currentOwner = {
                                label: element.firstName + ' ' + element.lastName,
                                value: element,
                            };
                        }
                        const obj = {
                            label: element.firstName + ' ' + element.lastName,
                            value: element,
                        };
                        this.owners.push(obj);
                    });
                    this.ownerFunctionSuccess = true;
                });
        }
    }

    public getAllApps(role) {
        if (role > 2) {
            this._appsService.getAllApps(this.dropdownPagination, 'name,asc').subscribe((data: any) => {
                // console.log('All Apps -> ', data.body);
                data.body.forEach((element) => {
                    if (this.selectedStore.app !== null && element.id === this.selectedStore.app.id) {
                        this.currentApp = { label: element.name, value: element };
                    }
                    const obj = {
                        label: element.name,
                        value: element,
                    };
                    this.apps.push(obj);
                });
                this.appFunctionSuccess = true;
            });
        }
    }

    public onStoreDetailsFormSubmit() {
        const values = this.storeDetailsForm.value;
        values.currency = values.currency.value;

        this._storeService.editStore(this.storeId, values).subscribe((data: any) => {
            this.getStore(this.storeId);
            this.initialise();
            this.notificationService.notify(
                'success',
                'Store Updated',
                'Store details successfully updated',
                'top',
                'right'
            );
        });
    }
}

interface OwnerUser {
    label: string;
    value: any;
}

interface GroupUser {
    label: string;
    value: any;
}

interface CustomerApp {
    label: string;
    value: any;
}



// WEBPACK FOOTER //
// ./src/app/indi-store/details/store-details.component.ts